import {DataFetcherRequest} from '@aboutyou/data-fetcher';
import {useEffect, useRef} from 'react';

export const useKeepPreviousRecommendationsData = () => {
  const keepPreviousData = useRef(false);

  const updateKeepPreviousData = (state: boolean) => {
    keepPreviousData.current = state;
  };

  return {
    keepPreviousData: keepPreviousData.current,
    updateKeepPreviousData,
  };
};

export const useUpdateKeepPreviousData = <Data extends object>(
  request: DataFetcherRequest<Data>,
  updateKeepPreviousData: (state: boolean) => void,
  productId: number | undefined,
) => {
  useEffect(() => {
    return () => {
      // reset the product tiles when switching from ADP to ADP to not render the old recommendations while the new are loading
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      updateKeepPreviousData(false);
    };
  }, [productId]);

  useEffect(() => {
    if (!request.isFetching) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      updateKeepPreviousData(true);
    }
  }, [request.isFetching]);
};
